import React, { useEffect } from 'react';
import './DisclaimerModal.css';

function DisclaimerModal({ onClose }) {
  // Clear any stored disclaimer text when this modal is opened
  useEffect(() => {
    try {
      localStorage.removeItem('disclaimerText');
    } catch (e) {
      // ignore
    }
  }, []);

  return (
    <div className="disclaimer-overlay" onClick={onClose}>
      <div className="disclaimer-modal" onClick={e => e.stopPropagation()}>
        <div className="disclaimer-header">
            <h2>Information</h2>
            <button className="disclaimer-close" onClick={onClose}>×</button>
        </div>
        <p>This website is meant to be used as a progression tracker for Animal Crossing: New Horizons critterpedia. 
        </p>

        <h3>Why does this website exist?</h3>
        <p>This application is deeply inspired by other similar projects but I wanted to make my own version since I found myself frustrated with some missing functionality that i wanted the application to have. For example, caught/uncaught status from the mainpage and more robust filtering.
        </p>

        <h3>Disclaimer</h3>
        <p>Artwork and in‑game assets displayed on this site originate from the video game Animal Crossing: New Horizons and are owned by Nintendo. They are reproduced here solely for fan and informational purposes to support tracking. This site is not affiliated with, endorsed by, or sponsored by Nintendo. All Nintendo trademarks and copyrights remain the property of their respective owners.</p>
      </div>
    </div>
  );
}

export default DisclaimerModal;
